module.exports = __webpack_public_path__ + "img/powered_by_strava.0622cec0.svg";